






import i18n from "@/plugins/i18n";
import CommunityLinkService, { CommunityLink, DefaultCommunityLinkId, FallBackLanguage } from "@/services/communitylink";
import Vue from "vue";
import storeHelper from "../../store/store-helper";
export default Vue.extend({
    name: "ToolbarHelp",
    data: () => {
        return {
            customHelpPageUrl: null
        };
    },
    computed: {
        userLanguage(): string {
            return i18n.locale;
        }
    },
    methods: {
        async helpButtonClickedAsync(): Promise<void> {
            let customHelpPageUrl: string = await storeHelper.settingsStore.getSettingAsync<string>("custom_help_page_url");
            if (customHelpPageUrl && customHelpPageUrl.length > 0) {
                window.open(customHelpPageUrl, "_blank");
            } else {
                const communityLinks: CommunityLink[] = await CommunityLinkService.getCommunityLinksAsync(
                    (window as any).project ?? window.location.href,
                    true
                );
                if (communityLinks?.length > 0) {
                    //get target url based on user language
                    var targetUrl = communityLinks
                        .find(
                            cl =>
                                cl.targets.some(target => target.language.substring(0, 2) === this.userLanguage) &&
                                cl.community_link_id !== DefaultCommunityLinkId
                        )
                        ?.targets.find(target => target.language.substring(0, 2) === this.userLanguage)?.url;

                    if (!targetUrl) {
                        //if no target url found, get the default/fallback url
                        const defaultLink = communityLinks.find(link => link.community_link_id === DefaultCommunityLinkId);
                        targetUrl =
                            defaultLink?.targets.find(target => target.language.substring(0, 2) === this.userLanguage)?.url ??
                            defaultLink?.targets.find(target => target.language.substring(0, 2) === FallBackLanguage.substring(0, 2))?.url;
                    }
                    window.open(targetUrl, "_blank");
                }
            }
        }
    }
});
